require('./style.less');

var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs')

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/searchNotAllowedView/view.js
 ** module id = 650
 ** module chunks = 0
 **/